import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import TimeTrackingEmployeeYearlyVacationDays = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeYearlyVacationDays;
import TimeTrackingEmployeeYearlyVacationDaysData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeYearlyVacationDaysData;
import TimeTrackingEmployee = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;

@Injectable({providedIn: 'root'})
export class TimeTrackingEmployeeYearlyVacationDaysService extends BaseEndpointService<TimeTrackingEmployeeYearlyVacationDays, TimeTrackingEmployeeYearlyVacationDaysData> {
  protected override multiSelectTextFields = ['id'] as const;

  public forEmployee(employee: TimeTrackingEmployee) {
    this.endpoint = `/time-tracking/employees/${employee.id}/yearly-vacation-days`;
  }
}
